import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResultType } from '../../../../../models/enums/result-type.enum';
import { ManagementApiService } from '../../../../../services';
import { UserMatrixModel } from '../../../models/user-matrix-model';
import { SuccessDialogComponent } from 'src/app/shared/info-dialogs/success-dialog/success-dialog.component';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
@Component({
    selector: 'app-matrix-modify',
    templateUrl: './matrix-modify.component.html',
    styleUrls: ['./matrix-modify.component.scss'],
})
export class MatrixModifyComponent implements OnInit {
    @Input() userMetrixName: string;
    @Input() userMatrixId: string;
    @Output() modelOpen: EventEmitter<boolean> = new EventEmitter();
    @Output() refreshMatrix: EventEmitter<boolean> = new EventEmitter();

    tooltip_position = 'above';
    closeResult: string;
    result: ResultType = ResultType.Error;
    matrixModifyFormGroup: UntypedFormGroup;
    isMatrixEditable: boolean;

    constructor(
        private modalService: NgbModal,
        private fb: UntypedFormBuilder,
        private mgmtApi: ManagementApiService,
        private globalEmittersService: GlobalEmittersService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private userUtilityService: UserUtilityService,
        private customValidatorService: CustomValidatorService
    ) {
        this.isMatrixEditable = false;
    }

    async ngOnInit(): Promise<void> {
        this.matrixModifyFormGroup = this.fb.group({
            matrixNewName: [this.userMetrixName, Validators.required],
        });

        // * checking access levels
        this.isMatrixEditable = await this.userUtilityService.checkUserPermissionDataAndRoute('matrix', userActions.Edit);
    }

    open(content) {
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                windowClass: 'my_modal_class',
                size: 'md',
                keyboard: false,
            })
            .result.then(
                (result) => {
                    this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
        this.modelOpen.emit(true);
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    updateMatrixName() {
        if (this.matrixModifyFormGroup.valid) {
            let matrix = new UserMatrixModel();
            matrix.userMatrixId = this.userMatrixId;
            matrix.name = this.matrixModifyFormGroup.get('matrixNewName').value;
            matrix.usage = 1;
            this.updateMatrix(matrix);
            this.modalService.dismissAll();
        }
        this.matrixModifyFormGroup.get('matrixNewName').reset();
    }

    async updateMatrix(matrix: UserMatrixModel) {
        this.ngxUiLoaderService.start();
        let result = await this.mgmtApi.updateMatrix(matrix).toPromise();
        // this.customToastService.genericToast(this.result);
        // this.refreshMatrix.emit(true);
        if (result.success === true) {
            let dialogRef = this.modalService.open(SuccessDialogComponent, {
                size: 'md',
            });
            dialogRef.componentInstance.message = 'JointId Updated Sucessfully!';
            this.globalEmittersService.refreshMatrix.subscribe((res) => {
                if (res === true) {
                    this.refreshMatrix.emit(true);
                }
            });
        } else {
            this.userUtilityService.errorModelPopup(result.message);
        }
        this.ngxUiLoaderService.stop();
    }

    handleInputEvent(event: KeyboardEvent, typeOfValidation?: string) {
        const charCode = event.key;
        if (!/^[a-zA-Z0-9- ]$/.test(charCode)) {
            event.preventDefault();
        }
    }
}
